let Fabric = {
	LOWER: "lower",
	UPPER: "upper",
	APPAREL: "(Apparel)",

	selectedFabric: null,

	jerseyFabrics: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/u90mvu3.png",
			fabric_name: "geaux mesh",
			fabric_percent: "100% Polyester",
			fabric_weight: "5.31oz"
		},
		{
			id: 2,
			fabric_image: "https://i.imgur.com/zYpFu8a.png",
			fabric_name: "sheaux mesh",
			fabric_percent: "92% Poly / 8% Elastic",
			fabric_weight: "7.76oz"
		},
		{
			id: 3,
			// fabric_image: "https://i.imgur.com/7GqlyYK.png",
			fabric_image: "https://i.imgur.com/Tk7QXhx.png",
			fabric_name: "preaux elite",
			fabric_percent: "88% Poly, 12% Elastic",
			fabric_weight: "5.31oz",
			disabled: true
		}
	],

	pantsFabrics: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/T0QkcJ8.png",
			fabric_name: "elite poly",
			fabric_percent: "93% Poly, 7% Elastic",
			fabric_weight: "8.55oz"
		}
	],

	apparelFabrics: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/y7IonnI.png",
			fabric_name: "M091",
			fabric_percent: "93% Poly / 7% Lycra",
			fabric_weight: "4.87oz"
		},
		{
			id: 2,
			fabric_image: "/images/MIDWEIGHT TECH FLEECE.jpg",
			fabric_name: "MIDWEIGHT TECH FLEECE",
			fabric_percent: "100% Polyester",
			fabric_weight: "7.82oz"
		},
	],

	apparelFabricsSaveDesign: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/y7IonnI.png",
			fabric_name: "M091",
			fabric_percent: "93% Poly / 7% Lycra",
			fabric_weight: "4.87oz"
		},

	],

	techFleeceFabrics: [
		{
			id: 1,
			fabric_image: "/images/MIDWEIGHT TECH FLEECE.jpg",
			fabric_name: "MIDWEIGHT TECH FLEECE",
			fabric_percent: "100% Polyester",
			fabric_weight: "7.82oz"
		},

	],

	headBandFabrics: [
		{
			id: 1,
			fabric_image: "/images/PL299.png",
			fabric_name: "PL299",
			fabric_percent: "87% PES / 13% Elastic",
			fabric_weight: "7.37oz"
		},
	],

	PoloFabrics: [
		{
			id: 1,
			fabric_image: "/images/PL298.png",
			fabric_name: "PL298",
			fabric_percent: "88% Polyester, 12% Elastane",
			fabric_weight: "7.37oz"
		},
	],


	jacketFabrics: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/XKmC5Yt.png",
			fabric_name: "M220",
			fabric_percent: "92% PES / 8% Elastic",
			fabric_weight: "5.31oz"
		}
	],
	
	techTeeApparelFabrics: [
		{
			id: 1,
			fabric_image: "https://i.imgur.com/u90mvu3.png",
			fabric_name: "geaux mesh",
			fabric_percent: "100% Polyester",
			fabric_weight: "5.31oz"
		},
		{
			id: 2,
			fabric_image: "https://i.imgur.com/zYpFu8a.png",
			fabric_name: "sheaux mesh",
			fabric_percent: "92% Poly / 8% Elastic",
			fabric_weight: "7.76oz"
		},
	],

	events: () => {
		const self = Fabric;
		const mainModalElement = $("#fabric-modal");

		mainModalElement.on("click", ".fabric-image", self.onImage);
		mainModalElement.on("click", ".fabric-btn-next", self.onNext);
	},

	showFabricsModal: () => {
		Fabric.setSelectedFabric();

		const element = $("#fabric-modal");

		let checkConfig = (!_.isUndefined(ub.config));

		if (checkConfig) {
			let con = ub.config;

			if (con.type === Fabric.UPPER) {
				Fabric.renderFabrics(Fabric.jerseyFabrics);
				if (con.blockPattern === "Midweight Tech Fleece Hoodie") {
					Fabric.renderFabrics(Fabric.techFleeceFabrics);
				}
				if (con.blockPattern === "Headband") {
					Fabric.renderFabrics(Fabric.headBandFabrics);
				}

				if (con.blockPattern === "Light Polo") {
					Fabric.renderFabrics(Fabric.PoloFabrics);
				}
			}
			

			if (con.type === Fabric.LOWER) {
				Fabric.renderFabrics(Fabric.pantsFabrics);
			}

			if (con.sport.includes(Fabric.APPAREL)) {

				con.blockPattern === "Jacket" ? Fabric.renderFabrics(Fabric.jacketFabrics) : Fabric.renderFabrics(Fabric.apparelFabrics);
				if (con.blockPattern === "Mens Loose Fit Tech Tee") {
					Fabric.renderFabrics(Fabric.techTeeApparelFabrics);
				}

				if (con.blockPattern === "Light Polo") {
					Fabric.renderFabrics(Fabric.PoloFabrics);
				}
			}

		}

		UIkit.modal(element, {
            bgClose: false,
            escClose: false,
            stack: true
        }).show();

        if(!_.isNull(ub.user.cart_item_id)) {
			let id = ub.current_material.settings.material.fabric.id;
			$(".fabric-check-span[data-id="+id+"]").removeClass("uk-hidden");
        }

        Fabric.events();
	},

	renderFabrics: (data) => {
		let fabrics = data;
		let tmpl = _.template(document.getElementById("fabric-template").innerHTML);

		$(".modal-fabric-list").html("");
	    $(".modal-fabric-list").html(tmpl({ fabrics }));
	},

	onImage: function() {
		let id = $(this).data("id");

		let checkConfig = (!_.isUndefined(ub.config));

		if (checkConfig) {
			let con = ub.config;

			if (con.type === Fabric.UPPER) {
				let fabObj = _.find(Fabric.jerseyFabrics, { id: id });
				let fabObjTechFleece = _.find(Fabric.techFleeceFabrics, { id: id });
				let fabObjHeadBand = _.find(Fabric.headBandFabrics, { id: id });
				let fabObjPolo = _.find(Fabric.PoloFabrics, { id: id });
				Fabric.selectedFabric = fabObj;
				if (con.blockPattern === "Midweight Tech Fleece Hoodie") {
					Fabric.selectedFabric = fabObjTechFleece;
				}

				if (con.blockPattern === "Headband") {
					Fabric.selectedFabric = fabObjHeadBand;			
				}

				if (con.blockPattern === "Light Polo") {
					Fabric.selectedFabric = fabObjPolo;
				}
			}

			if (con.type === Fabric.LOWER) {
				let fabObj = _.find(Fabric.pantsFabrics, { id: id });
				Fabric.selectedFabric = fabObj;
			}

			if (con.sport.includes(Fabric.APPAREL) && con.blockPattern !== "Light Polo") { 
				let fabObj = _.find(Fabric.apparelFabrics, { id: id });
				let fabObjJacket = _.find(Fabric.jacketFabrics, { id: id });
				let fabObjTechTeeApparel = _.find(Fabric.techTeeApparelFabrics, { id: id });
				con.blockPattern === "Jacket" ? Fabric.selectedFabric = fabObjJacket : Fabric.selectedFabric = fabObj;

				if (con.blockPattern === "Mens Loose Fit Tech Tee") {
					Fabric.selectedFabric = fabObjTechTeeApparel;
				}
			}
		}

		Fabric.highlightFabric(id);
	},

	highlightFabric: (id) => {
		$(".fabric-check-span").addClass("uk-hidden");
		$(".fabric-check-span[data-id="+id+"]").removeClass("uk-hidden");
	},

	onNext: () => {
		
		if(_.isNull(ub.user.cart_item_id)) {
			CartInformation.events.onShowCartsList();
			return;
        }

        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var parentWindow = window.parent;

		// Save Part Information
        if (typeof PartInformation === "object") {
            let labels = ub.data.modifierLabels;
            PartInformation.setupPartInformation(labels, ub.current_material.settings);
        }

        parentWindow.Loader.customizer.saving({stack: true});
        parentWindow.Loader.loading(1, 9);

        if (onReversibleSide2) {
            Reversible.funcs.onSaveDesignSide1();
            return;
        }

		_.delay(SaveDesign.events.onClickSave, 500);
	},

	setSelectedFabric: () => {
		if (typeof ub.current_material.settings.material !== 'undefined') {
			if (typeof ub.current_material.settings.material.fabric !== 'undefined') {
				Fabric.selectedFabric = ub.current_material.settings.material.fabric ?? null;
			}
		}
	}

}